export default __webpack_public_path__ + "27ebb1517d4700fb327dc9418d74d23a.jpg";